import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setCategoryCollection = async (context, type) => {
  if (context.state.categoryCollection && context.state.categoryCollection.length > 0) {
    return;
  }

  const body = { active: true, types: type };
  const { data } = await api().post('finance.get-category', body);

  context.commit(types.SET_CATEGORY_COLLECTION, data);
};
